import KJUR from 'jsrsasign';
import { hasValue, safeParseJSON } from '../general-helpers';
import { base64UrlDecode } from './decode-utils';

export const decodeJWT = (token) => {
    if (!hasValue(token)) {
        return undefined;
    }

    const tokenParts = token.split('.');

    if (tokenParts.length !== 3) {
        console.error('Invalid Token');
        return undefined;
    }

    try {
        const header = safeParseJSON(base64UrlDecode(tokenParts[0]));
        const payload = safeParseJSON(base64UrlDecode(tokenParts[1]));
        const signature = tokenParts[2];

        return {
            toString: () => token,
            header,
            payload,
            signature
        };
    } catch (err) {
        console.error(err);
        return undefined;
    }
};

export const encodeJWT = (header, payload, secret = '') => {
    try {
        const sHeader = JSON.stringify(header);
        const sPayload = JSON.stringify(payload);
        const sJWT = KJUR.jws.JWS.sign(null, sHeader, sPayload, secret);

        return sJWT;
    } catch (error) {
        console.error('Error encoding JWT:', error);
        return undefined;
    }
};

export const stripToken = (token, allowedAttributes, secret = '', overWriteHeader = undefined) => {
    const decoded = decodeJWT(token);

    if (!decoded) {
        console.error('Invalid token');
        return undefined;
    }

    const { header, payload } = decoded;

    const filteredPayload = Object.keys(payload)
        .filter((key) => allowedAttributes.includes(key))
        .reduce((obj, key) => {
            obj[key] = payload[key];
            return obj;
        }, {});

    const headerToEncode = {
        ...header,
        ...overWriteHeader
    };

    return encodeJWT(headerToEncode, filteredPayload, secret);
};
